import TextField from "@mui/material/TextField";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import InputLabel from "@mui/material/InputLabel";
import Box from "@mui/material/Box";
import { Button } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";

const Traccerconfig = () => {
  return (
    <div>
      {" "}
      <div className="main-content">
        <div>
          <h3>Traccar Configuration</h3>
        </div>
        <div className="boX">
          <div className="container">
            <div className="row">
              <div className="col-md-2 "></div>
              <div className="col-md-8 mt-3">
                <h6>SMTPAuth</h6>

                <Box sx={{ minWidth: 120 }}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">Ture</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="select Traccar Device ID"
                      sx={{ height: "48px", width: "100%" }}
                    >
                      <MenuItem value={10}>Ten</MenuItem>
                      <MenuItem value={20}>Twenty</MenuItem>
                      <MenuItem value={30}>Thirty</MenuItem>
                    </Select>
                  </FormControl>
                </Box>
              </div>
              <div className="col-md-2"></div>
            </div>
          </div>

          <div className="container">
            <div className="row">
              <div className="col-md-2 "></div>
              <div className="col-md-8">
                <div className="gps">
                  <h6>Port</h6>
                  <TextField
                    id="outlined-textarea"
                    label="587*"
                    multiline
                    variant="outlined"
                    sx={{ height: "48px", width: "100%" }}
                  />
                </div>
              </div>
              <div className="col-md-2"></div>
            </div>
          </div>
          <div className="container">
            <div className="row">
              <div className="col-md-2 "></div>
              <div className="col-md-8">
                <div className="gps">
                  <h6>EmailFrom</h6>
                  <TextField
                    id="outlined-textarea"
                    label="mysmtp2020@gmail.com*"
                    multiline
                    variant="outlined"
                    sx={{ height: "48px", width: "100%" }}
                  />
                </div>
              </div>
              <div className="col-md-2"></div>
            </div>
          </div>
          <div className="container">
            <div className="row">
              <div className="col-md-2 "></div>
              <div className="col-md-8">
                <div className="gps">
                  <h6>ReplyTo</h6>
                  <TextField
                    id="outlined-textarea"
                    label="mysmtp2020@gmail.com"
                    multiline
                    variant="outlined"
                    sx={{ height: "48px", width: "100%" }}
                  />
                </div>
              </div>
              <div className="col-md-2"></div>
            </div>
          </div>
          <div className="container">
            <div className="row">
              <div className="col-md-2"></div>
              <div className="col-md-8">
                <div className="mt-4 adD">
                  <button>Save Confi</button>
                </div>{" "}
              </div>
            </div>
          </div>
          <div className="container">
            <div className="row">
              <div className="col-md-2"></div>
              <div className="col-md-8">
                <div className="content">
                  <div className="url">
                    <h6>CRON URL : </h6>
                    <p>https://codeforts.com/vms/traccarsync</p>
                  </div>
                  <div className="url">
                    <h6>CRON COMMAND : </h6>
                    <div>
                      <p>wget -q -O- </p>
                    </div>
                  </div>
                  <p>https://codeforts.com/vms/traccarsync</p>

                  <div className="url mb-5">
                    <a className="anc">Run Cron Manually</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Traccerconfig;
